var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layer-control"},[_c('custom-expansion-panel',{attrs:{"data":_vm.layerGroups,"multiple-select":true},on:{"change":_vm.callback}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }